import type { DamageType } from '@/common/damage';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type GetDamageSuccessResponseType = DamageType;

/** With `deleted`, loads a deleted damage as a read-only preview (GH #331). */
export async function getDamage(
	damageId: string,
	{ deleted = false }: { deleted?: boolean } = {},
): Promise<GetDamageSuccessResponseType | null> {
	const response = await axios.get(
		`${API_URLS.DAMAGES.INDEX}/${damageId}`,
		deleted ? { params: { deleted: true } } : undefined,
	);
	return getResponse<GetDamageSuccessResponseType>(response.data);
}
